import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css'

// No CSS imports here, Bootstrap is loaded globally in index.html
// import './index.css'; // REMOVED

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
